export const SCANNERS_LIST_FILE = 'scanners.json'
export const STL_FILES_DIR = 'stls'

export const RECORDS_TAB_MODES = {
  selection: 'selection',
  edit: 'edit'
}
